export class DeleteKursantRequest {

    constructor(
        public kursantId: string,
        public grupaId: string
    ) {

    }

}


// WEBPACK FOOTER //
// ./src/app/services/delete-kursant-request.ts